import React from 'react';
import { motion } from 'framer-motion';

const AccessRestricted = ({ onLoginClick }) => {
  return (
    <div className="max-w-2xl mx-auto px-4 py-16">
      <motion.div
        className="text-center py-16 bg-white/90 backdrop-blur-xl rounded-3xl shadow-xl"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <img src="/images/001.gif" alt="Mora.Artt" className="w-28 h-28 mx-auto mb-6 rounded-full object-cover" />
        <h2 className="text-3xl font-bold text-gray-900 mb-3">Acceso restringido</h2>
        <p className="text-gray-600 mb-6">Debes iniciar sesión para continuar.</p>
        <motion.button
          onClick={onLoginClick}
          className="px-8 py-3 bg-gradient-to-r from-pink-500 to-purple-600 text-white font-bold rounded-xl shadow-lg hover:shadow-xl transition-all duration-300"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          Iniciar sesión
        </motion.button>
      </motion.div>
    </div>
  );
};

export default AccessRestricted;
